module.exports = __webpack_public_path__ + "static/img/2_2_5.d554c285.jpg";